import React from 'react';
import {isUserAdmin} from "../../Helper/auth";
import {Navigate} from "react-router-dom";

export default function AdminRoute({children}){
    return isUserAdmin() ? children : <Navigate to="/dashboard" />;
};